const { instance } = require('./url')

async function customQuery(sql) {
    return await instance.post('/custom_query/query', { sql })
}

async function getSavedQueries() {
    return await instance.get('/custom_query/saved')
}

async function saveQuery(name, sql) {
    return await instance.post('/custom_query/saved', { name, sql })
}

async function updateSavedQuery(id, name, sql) {
    return await instance.put('/custom_query/saved/' + id, { name, sql })
}

async function deleteSavedQuery(id) {
    return await instance.delete('/custom_query/saved/' + id)
}

export {
    customQuery,
    getSavedQueries,
    saveQuery,
    updateSavedQuery,
    deleteSavedQuery,
}
